import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../models/config';

@Injectable({
  providedIn: 'root',
})
export class HPayementService {
  constructor(private http: HttpClient) { }

  getCopyAndPayId(data: any, isRenew: boolean = false): any {
    if (isRenew) {
      return this.getCopyAndPayIdForRenew(data)
    }
    return this.http.post(
      `${Config.apiUrl}/HPayement/GetCopyAndPayId`,
      data
    );
  }
  getCopyAndPayIdForRenew(data: any) {
    return this.http.post(
      `${Config.apiUrl}/HPayement/GetCopyAndPayIdForRenew`,
      data
    );
  }

  getCheckoutStatus(params: any, isRenew = false): any {
    if (isRenew) {
      return this.getCheckoutStatusForRenew(params)
    }
    return this.http.post(
      `${Config.apiUrl}/HPayement/GetCheckoutStatus?chechoutId=${params.chechoutId}&trycount=${params.trycount}`,
      {
        transactionType: null,
        objectId: 0,
      }
    );
  }

  getCheckoutStatusForRenew(params: any): any {
    return this.http.post(
      `${Config.apiUrl}/HPayement/GetCheckoutStatusForRenew?chechoutId=${params.chechoutId}&trycount=${params.trycount}`,
      {
        transactionType: null,
        objectId: 0,
      }
    );
  }
}
